module.exports = __webpack_public_path__ + "static/media/arrow_right.7e82d101.svg";